import { TDR } from 'tdr-common';
import { useEstimateInvoice } from '../../hooks/useEstimateInvoice';
import React from 'react';

export default function PriceDisplay({ restaurant, table, time, searchFilters, featureFlags }: {
	restaurant: TDR.Restaurant;
	table: TDR.Table;
	time: string;
	searchFilters: any;
	featureFlags: any;
}) {
	const timeslotSearchFilters = {
		...searchFilters,
		time: time
	};
	const { estimatedInvoice } = useEstimateInvoice(restaurant, table, timeslotSearchFilters);

	const { placement, symbol } = TDR.CurrencyConfig[restaurant?.currency || TDR.Currency.USD];

	// Use inclusive pricing if feature flag is enabled and we have an estimated invoice
	let timeslotPrice: number;
	if (featureFlags?.inclusivePricing && estimatedInvoice) {
		timeslotPrice = estimatedInvoice.total;
	}
	else {
		timeslotPrice = estimatedInvoice?.subtotal;
	}

	return (
		<div className="text-tablz-text-gray-1 font-poppins text-base">
			{placement === TDR.CurrencyPlacement.BEFORE ? `${symbol} ${timeslotPrice}` : `${timeslotPrice} ${symbol}`}
		</div>
	);
}